export interface IProductForm {
  productName: string;
  brandId: string;
  // productPrice: number;
  categoryId: string;
  subCategoryId: string;
  productPrimaryImageUrl: string;
  multipleProductImageUrl: string[];
  productSpecification: string;
  installationFee: number;
  buyerNote: string;
  weight: number;
  slug: string;
  shortDescription: string;
  productCode: string;
  longDescription: string;
  monthlyFinancing: number;
  rating: number;
  productQuantity: number;
  productEnabled: boolean;
  isWarranty: boolean;
  productCurrentPrice: number;
  productPreviousPrice: number;
  applyVat: boolean;
  isDeliveryCarryOut?: boolean;
}

export class ProductForm {
  productName: string = "";
  brandId: string = "";
  // productPrice: number = 0;
  categoryId: string = "";
  subCategoryId: string = "";
  productPrimaryImageUrl: string = "";
  multipleProductImageUrl: string[] = [];
  productSpecification: string = "";
  minIvtCap: string = "";
  batType: string = "";
  batTypeValue: string = "";
  installationFee: number = 0;
  buyerNote: string = "";
  weight: number = 0;
  slug: string = "";
  shortDescription: string = "";
  productCode: string = "";
  longDescription: string = "";
  monthlyFinancing: number = 0;
  rating: number = 0;
  productQuantity: number = 0;
  productEnabled: boolean = false;
  isWarranty: boolean = false;
  productCurrentPrice: number = 0;
  productPreviousPrice: number = 0;
  applyVat: boolean = false;
  isDeliveryCarryOut?: boolean = false;
}
export class UpdateProductForm {
  productId: string = "";
  productName: string = "";
  rating: number = 0;
  brandId: string = "";
  categoryId: string = "";
  vendorId: string = "";
  subCategoryId: string = "";
  productPrimaryImageUrl: string = "";
  multipleProductImageUrl: string[] = [];
  multipleProductImageIds: string[] = [];
  productSpecification: string = "";
  installationFee: number = 0;
  buyerNote: string = "";
  weight: number = 0;
  slug: string = "";
  shortDescription: string = "";
  longDescription: string = "";
  monthlyFinancing: number = 0;
  productCode: string = "";
  productDescription: string = "";
  productEnabled: boolean = false;
  isWarranty: boolean = false;
  productCurrentPrice: number = 0;
  productPreviousPrice: number = 0;
  applyVat: boolean = false;
  isDeliveryCarryOut: boolean = false;
  productQuantity: number = 0;
}

export interface IProductSheet {
  Name: string;
  Brand: string;
  Price: number;
  Category: string;
  Description: string;
  Quantity: number;
  Note: string;
  "Weight(KG)": number;
  CarryOutDelivery?: boolean;
  ImageUrl1: string;
  ImageUrl2: string;
  ImageUrl3: string;
  ImageUrl4: string;
  ImageUrl5: string;
  "MinimumInverterCapacity(Inverters)": number;
  "BatteryType(Inverters)": string;
  "BatteryTypeValue(Inverters)": number;
}

export interface IFileDetails {
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}
export class FileDetails {
  name: string = "";
  size: number = 0;
  type: string = "";
  webkitRelativePath: string = "";
}

export interface IProductCategory {
  categoryId: string;
  category: string;
  banner: string | null;
  commision: number;
  isTopCategory: boolean;
  isRemoved: boolean;
}

export class ProductCategory {
  categoryName: string = "";
  banner: string = "";
  commision: string = "";
}

export interface ICategoryData {
  categoryId: string;
  category: string;
  banner: string | null;
  commision: number;
  isTopCategory: boolean;
  isRemoved: boolean;
}

export class ProductCategoryResponse {
  data: ICategoryData[] = [];
  responseCode: string = "";
  responseMessage: string = "";
  isSuccessful: boolean = false;
}

export interface IBrandData {
  brandName: string;
  image: string;
  brandId: string;
}

export interface IProductBrandResponse {
  data: IBrandData[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}
export interface IInverterTypes {
  batteryInvtId: string;
  batteryInvtName: string;
}
export interface IProductInverterTypesResponse {
  data: IInverterTypes[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IProduct {
  productId: string;
  vendorId: string;
  categoryId: string;
  subCategoryId: string;
  productName: string;
  brandName: [string];
  brandId: string;
  productPrice: number;
  productPrimaryImageUrl: string;
  productSpecification: string;
  minIvtCap: string;
  batType: string;
  batTypeValue: string;
  buyerNote: string;
  status: string;
  productQuantity: number;
  productCode: string;
  shortDescription: string;
  longDescription: string;
  weight: number;
  productImageUrl: [string];
  monthlyFinancing: number;
  rating: number;
  slug: string;
  installationFee: number;
  authoredAdmin: string;
  isEnable: boolean;
  isTopDeal: boolean;
  isBundle: boolean;
  availability: string;
  isWarranty: boolean;
  productCurrentPrice: number;
  productPreviousPrice: number;
  applyVat: boolean;
  isDeliveryCarryOut?: boolean;
  dateCreated: string;
}

export interface ISingleProduct {
  productId: string;
  vendorId: string;
  categoryId: string;
  subCategoryId: string;
  productName: string;
  brandName: [string];
  brandId: string;
  productPrice: number;
  productPrimaryImageUrl: string;
  productSpecification: string;
  buyerNote: string;
  status: string;
  productQuantity: number;
  productCode: string;
  shortDescription: string;
  longDescription: string;
  weight: number;
  inverterProduct: {
    inverterProductId: string;
    productId: string;
    vendorId: string;
    minIvtCap: string;
    laBatQty: string;
    twelveLithiumBatQty: string;
    twentyFourLithiumBatQty: string;
    fourtyEightLithiumBatQty: string;
    createdAt: "2023-11-14T15:09:25.0017782";
    updatedAt: null;
  };
  productImages: [
    {
      productImageId: string;
      vendorId: string;
      productId: string;
      productImageUrl: string;
      product: any;
      createdAt: string;
      updatedAt: any;
    }
  ];
  monthlyFinancing: number;
  rating: number;
  slug: string;
  installationFee: number;
  minIvtCap: string;
  batType: string;
  batTypeValue: string;
  authoredAdmin: string;
  isEnable: boolean;
  isTopDeal: boolean;
  isBundle: boolean;
  availability: string;
  isWarranty: boolean;
  productCurrentPrice: number;
  productPreviousPrice: number;
  applyVat: boolean;
  isDeliveryCarryOut?: boolean;
  productDescription: string;
  dateCreated: string;
}
export interface IProductsResponse {
  data: { productItemRequests: IProduct[] };
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IProductResponse {
  data: ISingleProduct;
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export class UpdateProductVisibility {
  isEnabled: boolean = false;
  productId: string = "";
}
